import { CloseIcon, HamburgerIcon } from '@chakra-ui/icons'
import {
  Avatar,
  Box,
  Flex,
  HStack,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Stack,
} from '@chakra-ui/react'
import React, { useState } from 'react'
import { useAppDispatch } from '../Hooks/useAppDispatch'
import { useAppSelector } from '../Hooks/useAppSelector'
import { getName, getRole, getToken, logout } from '../Redux/AdminSlice'
import { Link, useNavigate } from 'react-router-dom'

function Header() {
  const token = useAppSelector<string>(getToken)
  const name = useAppSelector<string>(getName)
  const role = useAppSelector<string>(getRole)

  const navigate = useNavigate()

  const [isOpen, setIsOpen] = useState(false)
  const onOpen = () => {
    setIsOpen(true)
  }
  const onClose = () => {
    setIsOpen(false)
  }

  const dispatch = useAppDispatch()

  const handleLogout = () => {
    dispatch(logout())
    window.location.reload()
  }

  return (
    <div>
      <Box bg='#F2F2F2' px={4} py={3}>
        {!token ? (
          <Flex h={16} alignItems={'center'} justifyContent={'center'}>
            <img src='logo1.png' style={{ height: '55px' }} />
          </Flex>
        ) : (
          <>
            <Flex alignItems={'center'} justifyContent={'space-between'}>
              {/* <IconButton
                size={'md'}
                icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
                aria-label={'Open Menu'}
                display={{ md: 'none' }}
                onClick={isOpen ? onClose : onOpen}
              /> */}

              <HStack spacing={8} alignItems={'center'}>
                <Box onClick={() => navigate('/home')}>
                  <img src='logo1.png' style={{ height: '55px' }} />
                </Box>
              </HStack>

              <Flex alignItems={'center'}>
                <Menu>
                  <MenuButton>
                    <Avatar size={'sm'} name={name} />
                  </MenuButton>
                  <MenuList>
                    <MenuItem>Role: {role}</MenuItem>
                    <MenuItem onClick={handleLogout}>Logout</MenuItem>
                  </MenuList>
                </Menu>
              </Flex>
            </Flex>

            {/* {isOpen ? (
              <Box pb={4} display={{ md: 'none' }}>
                <Stack as={'nav'} spacing={4}>
                  {role === 'admin' ? (
                    <Link to='/register'>Register</Link>
                  ) : null}
                  {role === 'admin' && (
                    <Link to='/whatsapp-responses'>Whatsapp</Link>
                  )}
                  {role === 'admin' && (
                    <Link to='/upload-translations'>Upload Translations</Link>
                  )}
                  <Link to='/addItem'>Add Item</Link>
                  {role === 'admin' || role === 'fots' ? (
                    <Link to='/onboarding'>Onboard</Link>
                  ) : null}
                </Stack>
              </Box>
            ) : null} */}
          </>
        )}
      </Box>
    </div>
  )
}

export default Header
